import archiver from 'archiver'
import path from 'path'

// The archive the pod unpacks, and it IS the service folder:
//
//   package/src/index.js       ← the service's source
//   package/public/icon.webp
//   package/package.json       ← the service's own manifest
//   package/package-lock.json
//   package/node_modules/**    ← the service's own dependencies
//
// So `serviceFilePath` is relative to the service ('src/index.js'), and `require` resolves by walking up
// from `package/src/` to `package/node_modules`. Nothing from the project root is in here.

export async function createServiceZip(
  definition: object,
  projectRoot: string,
  serviceId: string
): Promise<Buffer> {
  return new Promise((resolve, reject) => {
    const archive = archiver('zip', { zlib: { level: 9 } })
    const chunks: Buffer[] = []

    archive.on('data', (chunk: Buffer) => chunks.push(chunk))
    archive.on('end', () => resolve(Buffer.concat(chunks)))
    archive.on('error', reject)

    // Everything the service folder holds, `node_modules` included — the pod installs nothing.
    archive.directory(`${ path.resolve(projectRoot, 'services', serviceId) }/`, 'package')

    // Add definition.json next to package/ (for debugging/testing)
    archive.append(JSON.stringify(definition, null, 2), { name: 'definition.json' })

    archive.finalize()
  })
}
